export const marketingCommunicationsOptInParam = 'opt-in'

export const accountBetAccountQueryKey = 'marketing__bet-account'
